<template>
    <sui-image class="igc-item-banner"
        :src="`//tiem-cdn.qq.com/sy/${ $store.state.global.game }/ingame/images/banner.png`"
        @click.native="to"></sui-image>
</template>

<script>
import mCore from '../../scripts/mixins/core'

export default {
    name: 'igc-item-banner',

    mixins: [mCore],

    props: {
        url: {
            type: String,
            required: true
        },
        
        id: {
            type: String,
            required: true
        }
    },

    methods: {
        to() {
            this.mEventTracking('list_image', '列表_图片', {
                id: this.id
            })
            let url = this.url
            if (sessionStorage.tokenParams) {
                url = url.includes('?') ? url + sessionStorage.tokenParams.replace('?', '&') : url + sessionStorage.tokenParams
            }
            location.assign(url)
        }
    }
}
</script>

<style lang="postcss">
.igc-item-banner {
    height: 224px;
    margin-top: 20px;
    @media (orientation: portrait) {
        width: 100%;
    }
    @media (orientation: landscape) {
        width: calc((100% - 20px) / 2);
    }
}
</style>
